<template>
  <div>
    <div class="d-md-flex align-center justify-space-between">
      <h1 class="mb-0 mr-3">
        Offer Applications
      </h1>
      <div class="d-md-flex align-center justify-space-between fill-width">
        <v-btn @click="massAction('accepted')" color="primary" class="btn-inner non-transform" :disabled="!selected.length">
          Mass Approve
          <v-icon class="ml-2">mdi-check</v-icon>
        </v-btn>
        <v-btn @click="massAction('rejected')" color="error" class="btn-inner non-transform ml-3" :disabled="!selected.length">
          Mass Reject
          <v-icon class="ml-2">mdi-diameter-variant</v-icon>
        </v-btn>
      </div>
    </div>
    <div>
      <v-data-table
        :headers="table.headers"
        :header-props="{ sortIcon: null, headerClass: 'white-space-no-wrap' }"
        :items="applications"
        :disable-sort="true"
        :loading="table.loading"
        :footer-props="{itemsPerPageOptions: table.pageOptions}"
        :items-per-page="table.perPage"
        :expanded.sync="table.expanded"
        :single-expand="false"
        item-key="id"
        loading-text="Loading... Please wait"
        fixed-header
        :class="`elevation-1 fixed-height custom co-data-table items-size-${table.heightCounter}`"
        item-class="td_title"
        color="#7F98A5"
        show-select
        v-model="selected"
        @pagination="updateTablePagination"
      >
        <template v-slot:top>
          <DataTableTopBar @search="search" placeholder="Search"/>
        </template>
        <template v-for="item of table.headers" :slot="`header.${[item.value]}`" slot-scope="{header}">
          <data-filter
                  v-if="table.filters.hasOwnProperty(header.value)"
                  :type="['estimatedVolume'].includes(header.value) ? 'range' : (table.filters[header.value]['isDate'] ? 'date' : 'items')"
                  :min="0"
                  :max="1000"
                  :items="table.filters[header.value].data"
                  :entity="header.value"
                  :values="table.filters[header.value].selected"
                  @apply="submitFilter"
                  @search="updateDataInFilters"
          ></data-filter>
          <a v-if="header.sortable === undefined || header.sortable" @click="sortColumn(header.value)">
            <span class="header_title custom-header">{{header.text}}</span>
            <v-icon size="16" color="#7F98A5">mdi-arrow-{{header.value === table.orderBy ? table.sortColumnsAsc ? 'up' : 'down' : 'up-down'}}</v-icon>
          </a>
          <span v-else class="header_title custom-header">{{header.text}}</span>
        </template>
        <template #item.actions="{ item }">
          <span class="mr-1 action" @click="massAction('accepted', item.id)">
            <v-icon class="primary-color small-icon" >mdi-check</v-icon>
          </span>
          <span class="mr-1 action" @click="massAction('rejected', item.id)">
            <v-icon class="ml-1 small-icon" style="color: red">mdi-diameter-variant</v-icon>
          </span>
          <span class="mr-1 action" @click="">
            <v-icon class="ml-1 primary-color small-icon">mdi-history</v-icon>
          </span>
        </template>
        <template #item.audienceMatch="{ item }">
          <p v-for="match in item.audienceMatch">
            {{`${match.group} (${match.value}): ${match.response}`}}
          </p>
        </template>
        <template #item.promotionMethods="{ item }">
          <p v-for="method in item.promotionMethods">
            {{method}}
          </p>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>

  import {mapGetters, mapState} from 'vuex';

  import store from "@/store";
  import DataTableTopBar from '@/components/common/DataTableTopBar';
  import applications from "@/api/applications";

  export default {
    name: 'Applications',
    components: {
      DataTableTopBar
    },
    computed: {
      ...mapState('user', ['user']),
      ...mapGetters('applications', ['applications', 'filters']),
    },
    async created() {
      if (!this.user[0].can('review_application')){
        await this.$router.push('/403');
      }
    },
    async mounted() {
      await this.getTableData();
      await this.getFiltersData();
    },
    methods: {
      async sortColumn(column) {
        this.table.sortColumnsAsc = (this.table.orderBy === column) ? !this.table.sortColumnsAsc : true;
        this.table.orderBy = column;
        await this.getTableData();
      },
      addParamsToLocation(params) {
        const query = JSON.stringify(params) === '{}' ? this.$route.path :
                this.$route.path + '?' + Object.keys(params).map(
                key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
                ).join('&')
        history.pushState({},null, query);
      },
      updateTablePagination(params){
        if (
                (this.table.currentPage === params.page &&
                        this.table.perPage === params.itemsPerPage) ||
                this.table.pageChangedByMe
        ) {
          this.table.pageChangedByMe = false;
          return
        }
        this.table.currentPage = params.page
        this.table.perPage = params.itemsPerPage
        /* if(this.$route.query.filters) {
          this.updateFiltersFromQuery();
        }
        this.getTableData(); */
      },
      async getFiltersData() {
        Object.keys(this.table.filters).forEach(name => {
          if (this.filters[name]) {
            this.table.filters[name]['data'] = this.filters[name];
            if (this.table.filters[name]['isRange']) {
              this.table.filters[name].min = Number(this.filters[name].find(f => f.key === 'min')['value']);
              this.table.filters[name].max = Number(this.filters[name].find(f => f.key === 'max')['value']);
            }
          }

          this.table.filters[name].data = this.filters[name]
        })

      },
      async submitFilter(data, entity) {
        this.table.currentPage = 1;
        if(data && entity) {
          this.table.filters[entity].selected = data;
        }
        return await this.getTableData()
      },
      async getTableData() {
        this.table.loading = true;
        this.activateFilters();
        const filters = await this.getFilters();

        await store.dispatch('applications/getApplications', {
          limit: this.table.perPage,
          page: this.table.currentPage,
          orderBy: this.table.orderBy,
          orderDirectionAsc: this.table.sortColumnsAsc,
          filters: filters || null
        });

        this.table.loading = false

      },
      activateFilters() {
        const filtersForQuery = {};
        for (const name in this.table.filters) {
          if(this.table.filters[name].selected.length > 0) {
            filtersForQuery[name] = this.table.filters[name].selected;
          }
        }
        this.addParamsToLocation(
                JSON.stringify(filtersForQuery) !== '{}' ? {filters: JSON.stringify(filtersForQuery)} : {}
        );
      },
      async getFilters() {
        const filters = {};
        filters['search'] = this.table.searchInApplications || '';
        for(const name in this.table.filters) {
          filters[name] = (this.table.filters[name].selected.length > 0)
                  ? `${this.table.filters[name].selected.join(',')}`
                  : null;
        }

        return filters;
      },
      search(value) {
        this.table.searchInApplications = value;
        this.submitFilter();
      },
      async updateDataInFilters(data, modalName) {

      },
      async massAction(status, id = null) {
        this.table.loading = true;

        await store.dispatch('applications/massUpdate', {
          status,
          ids: id || this.selected.map(item => item.id)
        });

        await this.getTableData();

        this.selected = [];
        this.table.loading = false
      }
    },
    data() {
      return {
        selected: [],
        table: {
          searchInApplications: '',
          heightCounter: 45,
          currentPage: 1,
          perPage: 25,
          orderBy: '',
          sortColumnsAsc: true,
          pageOptions: [10, 25, 50, 100],
          loading: false,
          expanded: [],
          headers: [
            { text: 'Affiliate', value: 'affiliateName', align: 'center', sortable: true},
            { text: 'Offer', value: 'offerName', align: 'center', sortable: true },
            { text: 'Status', value: 'status', align: 'center' },
            { text: 'Email', value: 'email', align: 'left' }, // number of geos
            { text: 'DBA', value: 'dba', align: 'center', sortable: true },
            { text: 'Promotion Methods', value: 'promotionMethods', align: 'center', sortable: false },
            { text: 'Websites', value: 'websites', align: 'center', sortable: false},
            { text: 'Audience Match', value: 'audienceMatch', align: 'center', sortable: false },
            { text: 'Est. Volume', value: 'estimatedVolume', align: 'center', sortable: true},
            { text: 'Comments', value: 'comments', align: 'center', sortable: true },
            { text: 'Date', value: 'dateAdded', align: 'center', sortable: true },
            { text: 'Actions', value: 'actions', align: 'center', sortable: false },
          ],
          filters: {
            affiliateName: {selected: [], data: [], min: 0, max: 1, isRange: false},
            offerName: {selected: [], data: [], min: 0, max: 1, isRange: false},
            status: {selected: [], data: [], min: 0, max: 1, isRange: false},
            email: {selected: [], data: [], min: 0, max: 1, isRange: false},
            dba: {selected: [], data: [], min: 0, max: 1, isRange: false},
            promotionMethods: {selected: [], data: [], min: 0, max: 1, isRange: false},
            websites: {selected: [], data: [], min: 0, max: 1, isRange: false},
            estimatedVolume: {selected: [], data: [], min: 0, max: 1, isRange: true},
            comments: {selected: [], data: [], min: 0, max: 1, isRange: false},
            dateAdded: {selected: [], data: [], min: 0, max: 1, isRange: false, isDate: true},
          }
        },
      }
    }
  }
</script>

<style lang="sass">
  .small-icon
    font-size: 18px !important
  .custom-header
    font-size: 12px !important
  div.v-card.v-card--flat.v-sheet.theme--light.rounded-0.grey.lighten-4 > div.container.container_wrap.container--fluid > div:nth-child(2) > div:nth-child(2) > div > div.v-data-table__wrapper > table > tbody > tr > td
    font-size: 11px !important

  div.v-card.v-card--flat.v-sheet.theme--light.rounded-0.grey.lighten-4 > div.container.container_wrap.container--fluid > div:nth-child(2) > div:nth-child(2) > div > div.v-data-table__wrapper > table > tbody > tr > td > p
    font-size: 11px !important

  td.text-center, td.text-left
    margin: 4px !important
    padding: 2px !important

  .non-transform
    text-transform: none !important
  .action :hover
    cursor: pointer
  .copy-btn
    background: #acc3cf !important
    color: white !important
    width: 130px
    text-transform: unset !important
  .v-data-table-header th a span

  .card-custom
    background: #f5f5f5 !important
  .v-tooltip__content
    opacity: 1 !important
    background-color: #3A3852 !important
    .v-text-field-modifier
      width: 50px
    .scrollable-expand
      overflow-y: auto
      .v-data-table__wrapper
        height: auto !important
        .spacer
          width: 0
          padding-right: 40px
</style>

// eslint-disable-next-line no-undef